import axios from 'axios'
import moment from 'moment';
import { menuJumpTo } from "@/utils/menu-path/menu-path";
import { Http } from '@/utils';
export class SoftPhoneUtil {
  isMute: boolean = false;
  isHold: boolean = false;
  isOpen: boolean = false;
  isTransfer: boolean = false;
  outFlag: boolean = false;
  beginOB: boolean = false;
  inFlag: boolean = false;
  consultFlag: boolean = false;
  talkingFlag: boolean = false;

  serverIP: any = "";//主服务器IP地址
  serverPort: any = "";//主服务器端口
  messageAction: any = "";//消息获取action
  ajaxAction: any = "";//项目名称
  actionURL: any = "";//接口访问总地址
  recTime: any = new Date().getTime();//接收心跳信息时间
  agentCode: any = "";
  extension: any = "";
  currentAgentStatus: any = "LOGOUT";
  serviceGuid: any = "";

  vueInstance: any = null;
  iframeContext: any = null;
  websocket: any = null;
  
  public jsGetServersInfo(agentId: any, extension: any, context: any, iframeContext: any){
    this.vueInstance = context
    this.agentCode = agentId
    this.extension = extension
    this.iframeContext = iframeContext

    axios({
      method: 'get',
      url: '/callApi/SoftPhonePortal/softPhone/getServerInfo',
      params: {
        data: Math.random()
      },
      responseType: 'json'
    }).then((res: any) => {
      const msg: any = res.data
      if(msg.retCode=='1'){
        // 因电话条只能连接生产环境上的,暂时写死路径
        this.serverIP = "Softphone.jomoo.cn";
        // this.serverIP = msg.retAdditional.SERVICE_IP;
        this.serverPort = msg.retAdditional.SERVICE_PORT;
        this.messageAction = msg.retAdditional.MESSAGE_ACTION;
        this.ajaxAction = msg.retAdditional.AJAX_ACTION;
        this.checkSocket()
      } else {
        alert("初始化失败!");
      }
    })
  }
  
  public jsAgentLogin() {
    axios({
      method: 'get',
      url: '/callApi/SoftPhonePortal/softPhone/AgentLogin',
      params: {
        data: {
          DEVICE: this.extension,
          AGENTID: this.agentCode,
          MODE: 2,
          data: Math.random()
        }
      },
      responseType: 'json'
    }).then((res: any) => {
      const msg: any = res.data
      if(msg.retCode=='1'){
        this.jsWebSocket();
      } else {
        alert("登录失败" + msg.retDesc);
      }
    }).catch((res: any) => {
      alert("操作失败!"); 
    })					
  }

  public async jsDialCall(call_number: any) {
    axios({
      method : "get",
      url : "/callApi/SoftPhonePortal/softPhone/DialCallNumber",
      params: {
        CALLNUMBER: call_number,
        EXT: this.extension,
        data: Math.random()
      },
      responseType:"json",
    }).then((res: any) => {
      // const msg: any = res.data
    })
    .catch((res: any) => {
      alert("操作失败!"); 
    })
  }
  public async getTelLocation(call_number: any) {
    const params: any = call_number.substr(0, 7)
    return await axios.get(`/cssworkorderapi/wophonenumbermatches/fetchdefault?n_call_number_leftlike=${params}`)
  }
  public runCheckSocket(): any {
    let interval: any = setInterval(this.checkSocket, 30000);
  }

  public checkSocket(): any {
    if(this.websocket == null){
      console.log('websocket is null connect again...');
      this.jsWebSocket();
    }else{
      if(this.websocket.readyState!='1'){
        console.log('websocket is closed connect again...');
        this.websocket = null;
        this.jsWebSocket();
      }else{
        let diff = new Date().getTime() - this.recTime;
        if(diff>180000){
          console.log('websocket is blocked connect again...');
          this.websocket.close();
          // serverIP = backupServerIP;
          // serverPort = backupServerPort;
          // this.actionURL = "http://" + serverIP + ":" + serverPort + "/" + this.ajaxAction + "/";
          // 断掉重连不用重新登录电话条
          // this.jsAgentLogin();
          this.jsWebSocket();
        }
      }
    }
  }

  public jsWebSocket(): any {
    this.websocket = new WebSocket("wss://" + this.serverIP + ":" + this.serverPort  + "/" + this.messageAction);
    let _this: any = this

    this.websocket.onopen = function (evnt: any) {
      //websocket端口打开后需要发送握手信息分机号和座席工号
      _this.websocket.send("{ \"msgType\": \"LOGIN\", \"ext\": \"" + _this.extension + "\", \"agentId\": \"" + _this.agentCode + "\"}");
      _this.isOpen = true;
    };

    this.websocket.onmessage = function (evnt: any) {
        let msg = evnt.data;
        /**
          msg消息为json格式，属性如下
          msgType：消息类型
          callId：avaya的callerid
          ucid：avaya的ucid
          called：被叫
          calling：主叫
          uuiData：随入数据
        **/
        let obj =  eval('(' + msg + ')');
        let msgType = obj.msgType;
        if (msgType=='RINGING'){
          //分机振铃
          _this.jumpToPhoneCallPage(obj, false)
        } else if (obj.msgType=='RETRIEVED'){
          //分机hold恢复通话
        } else if (obj.msgType=='DISCONNECTED'){
          //分机挂机
        } else if (obj.msgType=='ESTABLISHED'){
          //分机通话
        } else if (obj.msgType=='INITIATED'){
          //分机摘机
        } else if (obj.msgType=='ORIGINATED'){
          //分机外拨开始
          // _this.jumpToPhoneCallPage(obj, true)
        } else if (obj.msgType=='HOLE'){
          //分机hold
        } else if (obj.msgType=='aes_down'){
          //aes服务shutdown
        } else if (obj.msgType=='aes_inService'){
          //aes服务恢复状态
        } else if (obj.msgType=='service_heart_beat'){
          _this.recTime = new Date().getTime();
        }
    };

    this.websocket.onerror = function (evnt: any) {
      
    };

    this.websocket.onclose = function (evnt: any) {
      
    }
  }
  /**
   * isDial - true:外拨， false: 接听
   */
  public jumpToPhoneCallPage($event: any, isDial: any) {
    let information:any=localStorage.getItem('user')
    var userInfo = JSON.parse(information);
    let sendLogParams:any = {
        phone:"",
        currentTime: moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
        currentUser: userInfo.userCode,
        agentCode:  this.agentCode,
        ext: this.extension,
        fingerprint: sessionStorage.getItem("Fingerprint"),
        ani: "",
        dnis: "",
        ucId: "",
    }
    this.runSendLog(sendLogParams)
    const callInfo: any = this.saveCallInfo($event, isDial)
    
    const deResParameters: any[] = [{ pathName: 'csswkd', parameterName: 'csswkd' },]
    const parameters: any[] = [
        { pathName: 'woworkorders', parameterName: 'woworkorder' },
        { pathName: 'callphoneedittop2', parameterName: 'callphoneedittop2' },
    ];
    
    // let data: any = Object.assign({}, {
    // 电话条跳转接听电话页面时暂不需要额外参数
    
    let data: any = Object.assign({}, callInfo, {
        soft_phone_number: isDial ? $event.called : $event.calling,
        agentCode:  this.agentCode,
        ext: this.extension
    })
    sendLogParams = {
      ...sendLogParams,
      ...callInfo
    }
    this.runSendLog(sendLogParams)
    // 暂存成功后话务条功能
    this.woClientContact(data);
    const routePath: any = this.vueInstance.$viewTool.buildUpRoutePath(this.vueInstance.$route, {}, deResParameters, parameters, [], data);
    this.vueInstance.$router.push(routePath);
    this.vueInstance.menuclick(this.replaceRegExp(routePath));
  }

  public woClientContact(queryParams:any) {
    // 暂存成功后话务条功能
    try {
      Http.getInstance().post('/cssworkorderapi/woClientContact/ex/create', queryParams ,false).then((res: any) => {}).catch((response: any) => {
        alert("电话推送失败:"+response?.data?.message)
      })
    } catch (error:any) {
      alert("错误:"+error)
    }
  }

  public runSendLog(queryParams:any) {
    // 记录电话条日志
    try {
      Http.getInstance().post('/runtimeapi/callLog/save', queryParams ,false).then((res: any) => {}).catch((response: any) => {
        console.log(response?.data?.message);
      })
    } catch (error:any) {
      console.log(error?.data);
    }
  }

  public replaceRegExp(path: string) {
    return path ? path.replace(/\/appindexview(\/null)?/, '') : ''
  }
  
  public saveCallInfo(msg: any, isDial: any) {
    const info: any = {
      ani: msg.calling,
      dnis: msg.called,
      callDate: moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
      callType: isDial ? '2' : '1',
      ucId: msg.ucid,
      phone: isDial ? msg.called : msg.calling
    }
    localStorage.setItem('callInfo', JSON.stringify(info))
    return info
  }
  
  public getCallInfo() {
    return JSON.parse(localStorage.getItem('callInfo')||'{}')
  }

  public clearCallInfo() {
    localStorage.removeItem('callInfo')
  }
}